import {
  SUCCESS_CREATE_PATIENT_NOTE,
  SUCCESS_DELETE_PATIENT_NOTE,
} from "Actions/PatientAction";
import {
  START_GET_REPEAT_ORDER_LIST,
  SUCCESS_GET_REPEAT_ORDER_LIST,
  ERROR_GET_REPEAT_ORDER_LIST,
  RESET_REPEAT_ORDER_STATE,
  START_DELETE_REPEAT_ORDER,
  SUCCESS_DELETE_REPEAT_ORDER,
  ERROR_DELETE_REPEAT_ORDER,
  START_REPEAT_ORDER_PATIENT_FIELD_LIST,
  SUCCESS_REPEAT_ORDER_PATIENT_FIELD_LIST,
  ERROR_REPEAT_ORDER_PATIENT_FIELD_LIST,
  START_CREATE_REPEAT_ORDER,
  SUCCESS_CREATE_REPEAT_ORDER,
  ERROR_CREATE_REPEAT_ORDER,
  START_UPDATE_REPEAT_ORDER,
  SUCCESS_UPDATE_REPEAT_ORDER,
  ERROR_UPDATE_REPEAT_ORDER,
  START_GET_SINGLE_REPEAT_ORDER,
  SUCCESS_GET_SINGLE_REPEAT_ORDER,
  ERROR_GET_SINGLE_REPEAT_ORDER,
  START_GET_SEARCH_REPEAT_ORDER,
  SUCCESS_GET_SEARCH_REPEAT_ORDER,
  ERROR_GET_SEARCH_REPEAT_ORDER,
  START_UPDATE_REPEAT_ORDER_DATE,
  SUCCESS_UPDATE_REPEAT_ORDER_DATE,
  ERROR_UPDATE_REPEAT_ORDER_DATE,
  START_UPDATE_GLOBAL_SETTING,
  SUCCESS_UPDATE_GLOBAL_SETTING,
  ERROR_UPDATE_GLOBAL_SETTING,
  START_GET_PRINT_REPEAT_ORDER_LIST,
  SUCCESS_GET_PRINT_REPEAT_ORDER_LIST,
  ERROR_GET_PRINT_REPEAT_ORDER_LIST,
  START_UPDATE_REPEAT_ORDER_NOTE,
  SUCCESS_UPDATE_REPEAT_ORDER_NOTE,
  ERROR_UPDATE_REPEAT_ORDER_NOTE,
  START_DELETE_REPEAT_ORDER_NOTE,
  SUCCESS_DELETE_REPEAT_ORDER_NOTE,
  ERROR_DELETE_REPEAT_ORDER_NOTE,
  START_GET_OOS_ORDER,
  SUCCESS_GET_OOS_ORDER,
  ERROR_GET_OOS_ORDER,
  START_GLOBAL_SETTING,
  SUCCESS_GLOBAL_SETTING,
  ERROR_GLOBAL_SETTING,
  START_CREATE_MULTI_ORDER,
  SUCCESS_CREATE_MULTI_ORDER,
  ERROR_CREATE_MULTI_ORDER,
  START_PRN_DRUG,
  SUCCESS_PRN_DRUG,
  ERROR_PRN_DRUG,
  START_GLOBAL_SETTING_ACCESS,
  SUCCESS_GLOBAL_SETTING_ACCESS,
  ERROR_GLOBAL_SETTING_ACCESS,
  START_PATIENT_MULTI_ORDER,
  SUCCESS_PATIENT_MULTI_ORDER,
  ERROR_PATIENT_MULTI_ORDER,
  START_NEXT_ORDER_CYCLE,
  SUCCESS_NEXT_ORDER_CYCLE,
  ERROR_NEXT_ORDER_CYCLE,
  START_ORDER_COUNT_TYPE,
  SUCCESS_ORDER_COUNT_TYPE,
  ERROR_ORDER_COUNT_TYPE,
  START_BULK_ORDER_COUNT,
  SUCCESS_BULK_ORDER_COUNT,
  ERROR_BULK_ORDER_COUNT,
  START_GET_BULK_ORDER_LIST,
  SUCCESS_GET_BULK_ORDER_LIST,
  ERROR_GET_BULK_ORDER_LIST,
  ERROR_CREATE_BULK_ORDERS,
  SUCCESS_CREATE_BULK_ORDERS,
  START_CREATE_BULK_ORDERS,
} from "Actions/RepeatOrderAction";

const initialState = {
  repeatOrderList: {
    loading: false,
    data: {},
    error: "",
  },
  createRepeatOrderData: {
    loading: false,
    data: {},
    error: {},
  },
  updateRepeatOrderData: {
    loading: false,
    data: {},
    error: {},
  },
  singleRepeatOrder: {
    loading: false,
    data: {},
    error: {},
  },
  searchRepeatOrder: {
    loading: false,
    data: {},
    error: {},
  },
  repeatOrderCount: {
    loading: false,
    data: {},
    error: "",
  },
  deleteRepeatOrder: {
    loading: false,
    data: {},
    error: {},
  },
  repeatOrderPatientFieldList: {
    loading: false,
    data: {},
    error: {},
  },
  updateRepeatOrderDates: {
    loading: false,
    data: {},
    error: {},
  },
  addMedicationInPatient: {
    loading: false,
    data: {},
    error: {},
  },
  globalSetting: {
    loading: false,
    data: {},
    error: {},
    success: null,
  },
  printRepeatOrderList: {
    loading: false,
    data: [],
  },
  updateRepeatOrderNoteData: {
    loading: false,
    data: {},
    error: {},
  },
  deleteRepeatOrderNote: {
    loading: false,
    data: {},
    error: {},
  },
  ossOrderList: {
    loading: false,
    data: {},
    error: {},
  },
  createMultiOrderData: {
    loading: false,
    data: {},
    error: {},
  },
  statusUpdate: {
    loading: false,
    data: {},
    error: {},
  },
  prnList: {
    loading: false,
    data: {},
    error: {},
  },
  globalSettingAccess: {
    loading: false,
    data: {},
    error: {},
  },
  patientMultiOrderData: {
    loading: false,
    data: {},
    error: {},
  },
  nextOrderCycleList: {
    loading: false,
    data: {},
    error: {},
  },
  orderCountTypeList: {
    loading: false,
    data: {},
    error: {},
  },
  orderCountOfBulkOrder: {
    loading: false,
    data: {},
    error: {},
  },
  bulkOrderList: {
    loading: false,
    data: {},
    error: {},
  },
  createBulkOrderData: {
    loading: false,
    data: {},
    error: {},
  },
};

export const RepeatOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_REPEAT_ORDER_STATE: {
      return {
        ...state,
        [action.key]: action?.payload || initialState[action.key],
      };
    }
    case START_GET_REPEAT_ORDER_LIST: {
      let oldList = state?.repeatOrderList?.data;
      return {
        ...state,
        repeatOrderList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
          success: false,
          requestPayload: action?.payload,
        },
      };
    }
    case SUCCESS_GET_REPEAT_ORDER_LIST: {
      let oldList = state?.repeatOrderList?.data;

      if (oldList?.list?.length > 0) {
        if (state?.repeatOrderList?.requestPayload?.q) {
          console.log("reched query condition");
        }
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        if (state?.repeatOrderList?.requestPayload?.q) {
          console.log("reched query condition 2");
        }
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        repeatOrderList: {
          loading: false,
          data: oldList,
          error: "",
          success: true,
        },
      };
    }
    case ERROR_GET_REPEAT_ORDER_LIST: {
      return {
        ...state,
        repeatOrderList: {
          loading: false,
          data: {},
          error: "",
          success: false,
        },
      };
    }
    case START_CREATE_REPEAT_ORDER: {
      return {
        ...state,
        createRepeatOrderData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_REPEAT_ORDER: {
      return {
        ...state,
        createRepeatOrderData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_REPEAT_ORDER: {
      return {
        ...state,
        createRepeatOrderData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_REPEAT_ORDER: {
      return {
        ...state,
        updateRepeatOrderData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_REPEAT_ORDER: {
  let oldList = state?.repeatOrderList?.data;
  let updatedData = action?.payload?.data;

  if (oldList && Array.isArray(oldList?.list)) {
    let newList = oldList?.list?.map((item) => {
      if (item?.id == action?.id) {
        return {
          ...item,
          ...(typeof updatedData === "object" ? updatedData : {}),
          is_review_prn: true,
          patient_medications:
            updatedData?.patient_medications || item.patient_medications,
          patien_medications_count:
            updatedData?.patien_medications_count ||
            item.patien_medications_count,
        };
      } else {
        return item;
      }
    });
    oldList = {
      ...oldList,
      list: newList,
    };
  }

      return {
        ...state,
        updateRepeatOrderData: {
          loading: false,
          data: action.payload,
          error: {},
        },
        repeatOrderList: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_UPDATE_REPEAT_ORDER: {
      return {
        ...state,
        updateRepeatOrderData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_SINGLE_REPEAT_ORDER: {
      let oldList = state?.singleRepeatOrder?.data;
      return {
        ...state,
        singleRepeatOrder: {
          loading: true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_SINGLE_REPEAT_ORDER: {
      let oldList = state?.singleRepeatOrder?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        singleRepeatOrder: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_SINGLE_REPEAT_ORDER: {
      return {
        ...state,
        singleRepeatOrder: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    // case START_UPDATE_REPEAT_ORDER: {
    //   return {
    //     ...state,
    //     updateRepeatOrderData: {
    //       loading: true,
    //       data: {},
    //       error: {},
    //     },
    //   };
    // }
    // case SUCCESS_UPDATE_REPEAT_ORDER: {
    //   let oldList = state?.repeatOrderList?.data;
    //   oldList.list = oldList?.list?.map((item) => {
    //     if (item?.id == action?.id) {
    //       return {
    //         ...item,
    //         ...action?.payload?.data,
    //       };
    //     } else {
    //       return item;
    //     }
    //   });

    //   return {
    //     ...state,
    //     updateRepeatOrderData: {
    //       loading: false,
    //       data: action.payload,
    //       error: {},
    //     },
    //     // repeatOrderList: {
    //     //   loading: false,
    //     //   data: oldList,
    //     //   error: "",
    //     // },
    //   };
    // }
    // case ERROR_UPDATE_REPEAT_ORDER: {
    //   return {
    //     ...state,
    //     updateRepeatOrderData: {
    //       loading: false,
    //       data: {},
    //       error: action.payload,
    //     },
    //   };
    // }
    case START_GET_SEARCH_REPEAT_ORDER: {
      return {
        ...state,
        searchRepeatOrder: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_SEARCH_REPEAT_ORDER: {
      let oldList = action.payload.data;
      oldList.drugs = oldList?.drugs?.map((item) => {
        return {
          ...item,
          action: true,
        };
      });
      return {
        ...state,
        searchRepeatOrder: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_GET_SEARCH_REPEAT_ORDER: {
      return {
        ...state,
        searchRepeatOrder: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DELETE_REPEAT_ORDER: {
      return {
        ...state,
        deleteRepeatOrder: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_REPEAT_ORDER: {
      let oldList = state?.repeatOrderList?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        deleteRepeatOrder: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_DELETE_REPEAT_ORDER: {
      return {
        ...state,
        deleteRepeatOrder: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_REPEAT_ORDER_PATIENT_FIELD_LIST: {
      let oldList = state?.repeatOrderPatientFieldList?.data;
      return {
        ...state,
        repeatOrderPatientFieldList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_REPEAT_ORDER_PATIENT_FIELD_LIST: {
      let oldList = state?.repeatOrderPatientFieldList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        repeatOrderPatientFieldList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_REPEAT_ORDER_PATIENT_FIELD_LIST: {
      return {
        ...state,
        repeatOrderPatientFieldList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_REPEAT_ORDER_DATE: {
      return {
        ...state,
        updateRepeatOrderDates: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_REPEAT_ORDER_DATE: {
  let oldList = state?.repeatOrderList?.data;
  let reqPayload = action?.requestPayload || {};
  let updatedData = action?.payload?.data;
  let targetId = reqPayload?.id || (typeof updatedData === "object" ? updatedData?.id : null);

  if (oldList && Array.isArray(oldList?.list) && targetId) {
    let newList = oldList?.list?.map((item) => {
      if (item?.id == targetId) {
        return {
          ...item,
          ...(typeof updatedData === "object" ? updatedData : {}),
          ...(reqPayload?.order_date ? { order_date: reqPayload.order_date } : {}),
          ...(reqPayload?.medication_date !== undefined ? { medication_date: reqPayload.medication_date } : {}),
        };
      } else {
        return item;
      }
    });
    oldList = {
      ...oldList,
      list: newList,
    };
  }

  return {
    ...state,
    updateRepeatOrderDates: {
      loading: false,
      data: action.payload,
      error: {},
    },
    repeatOrderList: {
      ...state.repeatOrderList,
      data: oldList,
    },
  };
}
    case ERROR_UPDATE_REPEAT_ORDER_DATE: {
      return {
        ...state,
        updateRepeatOrderDates: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GLOBAL_SETTING_ACCESS: {
      return {
        ...state,
        globalSettingAccess: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_GLOBAL_SETTING_ACCESS: {
      return {
        ...state,
        globalSettingAccess: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_GLOBAL_SETTING_ACCESS: {
      return {
        ...state,
        globalSettingAccess: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GLOBAL_SETTING: {
      return {
        ...state,
        globalSetting: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_GLOBAL_SETTING: {
      let tempObj = {};
      if (action.payload) {
        tempObj = {
          repeatOrderSetting: action.payload.preferred_ordergap,
          chaseUpSetting: action.payload.chase_up,
          archiveDaysSetting: action.payload.archive_days,
          DriverHoursSetting: action.payload.driver_hours,
          ccPharmacyEmailSetting: action.payload.cc_orders_to_pharmacy,
        };
      }
      return {
        ...state,
        globalSetting: {
          loading: false,
          data: tempObj,
          error: {},
        },
      };
    }
    case ERROR_GLOBAL_SETTING: {
      return {
        ...state,
        globalSetting: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_GLOBAL_SETTING: {
      return {
        ...state,
        globalSetting: {
          loading: true,
          data: state.globalSetting.data,
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_GLOBAL_SETTING: {
      let tempObj = state.globalSetting.data;
      if (action.actionType == "repeatOrder") {
        tempObj.repeatOrderSetting = action.payload;
      } else {
        tempObj.chaseUpSetting = action.payload;
      }
      return {
        ...state,
        globalSetting: {
          loading: false,
          data: tempObj,
          success: true,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_GLOBAL_SETTING: {
      return {
        ...state,
        globalSetting: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_PRINT_REPEAT_ORDER_LIST: {
      return {
        ...state,
        printRepeatOrderList: {
          loading: true,
          data: [],
        },
      };
    }
    case SUCCESS_GET_PRINT_REPEAT_ORDER_LIST: {
      return {
        ...state,
        printRepeatOrderList: {
          loading: false,
          data: action?.payload?.data?.list,
        },
      };
    }
    case ERROR_GET_PRINT_REPEAT_ORDER_LIST: {
      return {
        ...state,
        printRepeatOrderList: {
          loading: false,
          data: [],
        },
      };
    }
    case START_UPDATE_REPEAT_ORDER_NOTE: {
      return {
        ...state,
        updateRepeatOrderNoteData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_REPEAT_ORDER_NOTE: {
      let oldList = state?.repeatOrderList?.data;
      let newList = oldList?.list?.map((item) => {
        if (item?.id === action?.id) {
          const hadNote = Boolean(item.order_notes);
          const hasNote = Boolean(action?.payload?.data?.order_notes);
          let newNoteCount = Number(item?.note_count) || 0;
          if (!hadNote && hasNote) {
            newNoteCount += 1;
          }
          return {
            ...item,
            order_notes: action?.payload?.data?.order_notes,
            note_count: newNoteCount,
          };
        }
        return item;
      });
      return {
        ...state,
        repeatOrderList: {
          ...state.repeatOrderList,
          data: {
            ...oldList,
            list: newList,
          },
        },
        updateRepeatOrderNoteData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_REPEAT_ORDER_NOTE: {
      return {
        ...state,
        updateRepeatOrderNoteData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DELETE_REPEAT_ORDER_NOTE: {
      return {
        ...state,
        deleteRepeatOrderNote: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_REPEAT_ORDER_NOTE: {
      let oldList = state?.repeatOrderList?.data;
      let newList = oldList?.list?.map((item) => {
        if (item?.id === action?.id) {
          const hadNote = Boolean(item.order_notes);
          let newNoteCount = Number(item?.note_count) || 0;
          if (hadNote) {
            newNoteCount = Math.max(0, newNoteCount - 1);
          }
          return {
            ...item,
            order_notes: null,
            note_count: newNoteCount,
          };
        }
        return item;
      });
      return {
        ...state,
        repeatOrderList: {
          ...state.repeatOrderList,
          data: {
            ...oldList,
            list: newList,
          },
        },
        deleteRepeatOrderNote: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_PATIENT_NOTE: {
      const patientId =
        action?.patient_id ||
        action?.payload?.data?.patient_id ||
        action?.requestPayload?.patient_id;
      let oldList = state?.repeatOrderList?.data;
      if (!oldList?.list) return state;
      let newList = oldList?.list?.map((item) => {
        if (patientId && (item?.patient_id == patientId || item?.id == patientId)) {
          return {
            ...item,
            note_count: (Number(item?.note_count) || 0) + 1,
          };
        }
        return item;
      });
      return {
        ...state,
        repeatOrderList: {
          ...state.repeatOrderList,
          data: {
            ...oldList,
            list: newList,
          },
        },
      };
    }
    case SUCCESS_DELETE_PATIENT_NOTE: {
      const patientId =
        action?.patient_id ||
        action?.payload?.data?.patient_id ||
        action?.requestPayload?.patient_id;
      let oldList = state?.repeatOrderList?.data;
      if (!oldList?.list) return state;
      let newList = oldList?.list?.map((item) => {
        if (patientId && (item?.patient_id == patientId || item?.id == patientId)) {
          return {
            ...item,
            note_count: Math.max(0, (Number(item?.note_count) || 0) - 1),
          };
        }
        return item;
      });
      return {
        ...state,
        repeatOrderList: {
          ...state.repeatOrderList,
          data: {
            ...oldList,
            list: newList,
          },
        },
      };
    }
    case ERROR_DELETE_REPEAT_ORDER_NOTE: {
      return {
        ...state,
        deleteRepeatOrderNote: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_OOS_ORDER: {
      return {
        ...state,
        ossOrderList: {
          loading: true,
          data: {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_OOS_ORDER: {
      let oldList = state?.ossOrderList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        ossOrderList: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_OOS_ORDER: {
      return {
        ...state,
        ossOrderList: {
          loading: false,
          data: {},
          error: "",
        },
      };
    }
    case START_CREATE_MULTI_ORDER: {
      return {
        ...state,
        createMultiOrderData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_MULTI_ORDER: {
      return {
        ...state,
        createMultiOrderData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_MULTI_ORDER: {
      return {
        ...state,
        createMultiOrderData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_PATIENT_MULTI_ORDER: {
      return {
        ...state,
        patientMultiOrderData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_PATIENT_MULTI_ORDER: {
      return {
        ...state,
        patientMultiOrderData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_PATIENT_MULTI_ORDER: {
      return {
        ...state,
        patientMultiOrderData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_NEXT_ORDER_CYCLE: {
      return {
        ...state,
        nextOrderCycleList: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_NEXT_ORDER_CYCLE: {
      return {
        ...state,
        nextOrderCycleList: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_NEXT_ORDER_CYCLE: {
      return {
        ...state,
        nextOrderCycleList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }

    case START_PRN_DRUG: {
      return {
        ...state,
        prnList: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_PRN_DRUG: {
      let oldList = state?.repeatOrderList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        prnList: {
          loading: false,
          data: action.payload,
          error: {},
        },
        // repeatOrderList: {
        //   loading: false,
        //   data: oldList,
        //   error: "",
        // },
      };
    }
    case ERROR_PRN_DRUG: {
      return {
        ...state,
        prnList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_ORDER_COUNT_TYPE: {
      return {
        ...state,
        orderCountTypeList: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_ORDER_COUNT_TYPE: {
      return {
        ...state,
        orderCountTypeList: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_ORDER_COUNT_TYPE: {
      return {
        ...state,
        orderCountTypeList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_BULK_ORDER_COUNT: {
      return {
        ...state,
        orderCountOfBulkOrder: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_BULK_ORDER_COUNT: {
      return {
        ...state,
        orderCountOfBulkOrder: {
          loading: false,
          data: action.payload?.data,
          error: {},
        },
      };
    }
    case ERROR_BULK_ORDER_COUNT: {
      return {
        ...state,
        orderCountOfBulkOrder: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }

    case START_GET_BULK_ORDER_LIST: {
      return {
        ...state,
        bulkOrderList: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_BULK_ORDER_LIST: {
      return {
        ...state,
        bulkOrderList: {
          loading: false,
          data: action.payload?.data,
          error: {},
        },
      };
    }
    case ERROR_GET_BULK_ORDER_LIST: {
      return {
        ...state,
        bulkOrderList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }


    case START_CREATE_BULK_ORDERS: {
      return {
        ...state,
        createBulkOrderData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_BULK_ORDERS: {
      return {
        ...state,
        createBulkOrderData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_BULK_ORDERS: {
      return {
        ...state,
        createBulkOrderData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }

    default: {
      return state || initialState;
    }
  }
};
